// extracted by mini-css-extract-plugin
export var primarySolid = "Button-module--primarySolid--B6iSs";
export var primaryOutline = "Button-module--primaryOutline--+-dyy";
export var secondaryOutline = "Button-module--secondaryOutline--Qk1hg";
export var neutralOutline = "Button-module--neutralOutline--Bp8du";